import React, { useState, useEffect } from 'react';
import apiClient from '../../services/apiClient';
import './StreakExamModal.css';
import sirenImg from '../../images/dashboard/siren.png';
import Snackbar from "../common/Snackbar";

const StreakExamModal = ({ userId, onClose, onExamCompleted }) => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showWarning, setShowWarning] = useState(false);
  const [snackbars, setSnackbars] = useState([]);
const addSnackbar = (snackbar) =>
  setSnackbars((prev) => [...prev, snackbar]);

const handleCloseSnackbar = (index) =>
  setSnackbars((prev) => prev.filter((_, i) => i !== index));
  // Formatted current date logic for header
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }) + ' | ' + today.toLocaleDateString('en-GB', { weekday: 'short' });

  useEffect(() => {
    fetchTodaysQuestions();
  }, [userId]);

  const fetchTodaysQuestions = async () => {
    try {
      setLoading(true);
      const jwtToken = localStorage.getItem('jwtToken');
      // Step 2 & 4 handling based on the prompt. If user hasn't attempted, get today's.
      // But we probably just call todaysQuestions always for the content.
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const dateString = `${year}-${month}-${day}`;

      console.log(`Fetching questions for date: ${dateString}...`);
      const response = await apiClient.get(`/streak/questions/${dateString}`);

      console.log("Questions response:", response.data);
      if (response.data && response.data.length > 0) {
        setQuestions(response.data);
      } else {
        console.log("No questions or empty.");
        setError("No questions available for today.");
      }
    } catch (err) {
      console.error("Failed to fetch streak questions", err);
      // Fallback fallback questions if there's a network issue just to test UI locally
      setError("Unable to load today's streak exam.");
    } finally {
      setLoading(false);
    }
  };

  const handleOptionSelect = (optionKey) => {
    if (isSubmitted) return; // Prevent changing answer after submit
    setSelectedAnswers(prev => ({
      ...prev,
      [currentQuestionIndex]: optionKey
    }));
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(prev => prev - 1);
    }
  };

  const handleSubmit = async () => {

    // Check if all questions attempted
    if (Object.keys(selectedAnswers).length < questions.length) {
    addSnackbar({
  message: "Attempt all the questions to submit the test",
  type: "error"   // 🔥 THIS FIXES GREEN ISSUE
});
return;
    }

    try {
      await apiClient.post(`/streak/${userId}/complete`, selectedAnswers);
      addSnackbar({
  message: "Your streak submitted successfully",
  type: "success"
});
      setIsSubmitted(true);

      if (onExamCompleted) {
        onExamCompleted();
      }

    } catch (err) {
      console.error("Failed to submit streak exam", err);

      if (err.response && err.response.status === 409) {
        setIsSubmitted(true);
        if (onExamCompleted) onExamCompleted();
      } else {
        alert(err.response?.data?.message || "Failed to submit exam results.");
      }
    }
  };

  const handleCloseClick = () => {
    if (isSubmitted) {
      onClose();
    } else {
      setShowWarning(true);
    }
  };

  const handleConfirmClose = () => {
    setShowWarning(false);
    onClose();
  };

  const handleCancelClose = () => {
    setShowWarning(false);
  };

  if (loading) {
    return (
      <div className="streak-modal-overlay">
        <div className="streak-modal-content loading-state">
          <div className="spinner"></div>
          <p>Loading today's streak...</p>
        </div>
      </div>
    );
  }

  if (error || questions.length === 0) {
    console.log("Returning error state. error:", error, "questions.length:", questions.length);
    return (
      <div className="streak-modal-overlay">

        <div className="streak-modal-content">
          <div className="streak-modal-header">
            <div className="streak-header-titles">
              <h2>Today streak exam</h2>
            </div>
            <button className="streak-close-btn" onClick={onClose} aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" fill="#2A4157" fillOpacity="0.24" />
                <path d="M16 8L8 16" stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 8L16 16" stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
          <div className="streak-question-body" style={{ textAlign: "center", padding: "40px 0" }}>
            <p>{error || "No questions found for today."}</p>
          </div>
        </div>
      </div>
    );
  }

  const currentQuestion = questions[currentQuestionIndex];

  return (
    <div className="streak-modal-overlay">
     {snackbars.map((snackbar, index) => (
  <Snackbar
    key={index}
    index={index}
    message={snackbar.message}
    type={snackbar.type}
    onClose={handleCloseSnackbar}
  />
))}
      <div className="streak-modal-content">
        {/* Warning Popup */}
        {showWarning && (
          <div className="streak-warning-overlay">
            <div className="streak-warning-modal">
              <button className="streak-close-btn" onClick={handleCancelClose} aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" fill="#2A4157" fillOpacity="0.24" />
                  <path d="M16 8L8 16" stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M8 8L16 16" stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="warning-icon-wrapper">
                <img src={sirenImg} alt="Warning Icon" className="warning-siren-icon" />
              </div>
              <h2 className="warning-title">Warning!</h2>
              <p className="warning-text">You are about to close the exam.<br />You can check notifications later to take the test. Do you wish to close the test now?</p>
              <button className="warning-sure-btn" onClick={handleConfirmClose}>I'm Sure</button>
            </div>
          </div>
        )}

        {/* Main Modal Header */}
        <div className="streak-modal-header">
          <div className="streak-header-titles">
            <h2>Today streak exam</h2>
            <span className="streak-date">{formattedDate}</span>
          </div>

          <button className="streak-close-btn" onClick={handleCloseClick} aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" fill="#2A4157" fillOpacity="0.24" />
              <path d="M16 8L8 16" stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8 8L16 16" stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        {/* Progress Bar */}
        {!isSubmitted && (
          <div className="streak-progress-section">
            <div className="streak-progress-bars">
              {questions.map((_, index) => (
                <div
                  key={index}
                  className={`progress-segment ${index <= currentQuestionIndex ? 'active' : ''}`}
                ></div>
              ))}
            </div>
            <div className="streak-question-count">
              Question {currentQuestionIndex + 1}/{questions.length}
            </div>
          </div>
        )}

        {/* Question Body */}
        <div className={`streak-question-body ${isSubmitted ? 'submitted-questions-list' : ''}`}>
          {isSubmitted ? (
            questions.map((q, qIndex) => (
              <div key={qIndex} className="submitted-question-block">
                <h3 className="streak-question-text">
                  {qIndex + 1}. {q.question}
                </h3>
                <div className="streak-options-container">
                  {q.options && Object.entries(q.options).map(([key, value]) => {
                    const isSelected = selectedAnswers[qIndex] === key;
                    let optionClass = "streak-option";

                    if (isSelected) optionClass += " selected";
                    if (key === q.correctAnswer) {
                      optionClass += " correct";
                    } else if (isSelected && key !== q.correctAnswer) {
                      optionClass += " incorrect";
                    }

                    return (
                      <label key={key} className={optionClass}>
                        <input
                          type="radio"
                          disabled
                          checked={isSelected || key === q.correctAnswer}
                          readOnly
                        />
                        <span className="option-text">{value}</span>
                      </label>
                    );
                  })}
                </div>
                {q.description && (
                  <div className="streak-description-box">
                    <strong>Explanation:</strong> {q.description}
                  </div>
                )}
              </div>
            ))
          ) : (
            <>
              <h3 className="streak-question-text">{currentQuestion.question}</h3>

              <div className="streak-options-container">
                {currentQuestion.options && Object.entries(currentQuestion.options).map(([key, value]) => {
                  const isSelected = selectedAnswers[currentQuestionIndex] === key;
                  let optionClass = "streak-option";

                  if (isSelected) optionClass += " selected";

                  return (
                    <label key={key} className={optionClass}>
                      <input
                        type="radio"
                        name={`question-${currentQuestionIndex}`}
                        value={key}
                        checked={isSelected}
                        onChange={() => handleOptionSelect(key)}
                        disabled={isSubmitted}
                      />
                      <span className="option-text">{value}</span>
                    </label>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {/* Footer Actions */}
        <div className="streak-modal-footer">
          <div className="footer-left-buttons">
            {!isSubmitted && (
              <>
                <button
                  className="streak-nav-btn"
                  onClick={handlePrev}
                  disabled={currentQuestionIndex === 0}
                >
                  Prev
                </button>
                {currentQuestionIndex < questions.length - 1 && (
                  <button
                    className="streak-nav-btn"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                )}
              </>
            )}
          </div>
          <div className="footer-right-buttons">
            {!isSubmitted ? (
              currentQuestionIndex === questions.length - 1 && (
                <button
                  className="streak-submit-btn"
                  onClick={handleSubmit}
                  disabled={false}
                >
                  Submit
                </button>
              )
            ) : (
              <button
                className="streak-submit-btn"
                onClick={() => {
                  onClose();
                }}
              >
                Finish
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreakExamModal;
